import React, { useState, useEffect } from "react";
import ScrollAnimation from "react-animate-on-scroll";
import { Container, NewsHeader, NewsContent } from "./styles"; // Import styles from the styles.ts file
import newsImage1 from "../../assets/News1.png"; // Replace with your actual image paths
import newsImage2 from "../../assets/News2.png";
import newsImage3 from "../../assets/News5.png";
import newsImage4 from "../../assets/News4.png";
import newsImage5 from "../../assets/News3.png";
type NewsProps = {
  // Add any props if needed
};

export function News({}: NewsProps) {
  const [currentIndex, setCurrentIndex] = useState(0); // Track the current slide index
  const images = [newsImage1, newsImage2, newsImage3, newsImage4, newsImage5]; // Array of images

  // Function to move to the next slide
  const nextSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  // Function to move to the previous slide
  const prevSlide = () => {
    setCurrentIndex(
      (prevIndex) => (prevIndex - 1 + images.length) % images.length
    );
  };

  // Set up autoplay with interval
  useEffect(() => {
    const autoplay = setInterval(nextSlide, 6000); // 3 seconds interval
    return () => clearInterval(autoplay); // Clean up the interval on unmount
  }, []);

  return (
    <Container>
      {/* ScrollAnimation added to fade-in effect for NewsHeader */}
      <ScrollAnimation animateIn="fadeInUp" duration={1.5}>
        <NewsHeader>Latest News</NewsHeader>
      </ScrollAnimation>

      {/* Carousel with ScrollAnimation for the images */}
      <ScrollAnimation animateIn="fadeInUp" duration={1.5}>
        <div className="carousel">
          <div className="carousel-images">
            <img
              src={images[currentIndex]}
              alt={`News ${currentIndex + 1}`}
              style={{
                width: "100%",
                height: "auto",
                transition: "opacity 0.5s",
              }}
            />
          </div>

          {/* Navigation Arrows */}
          <button className="prev" onClick={prevSlide}>
            &#10094;
          </button>
          <button className="next" onClick={nextSlide}>
            &#10095;
          </button>
        </div>
      </ScrollAnimation>

      {/* ScrollAnimation added to fade-in effect for NewsContent */}
      <ScrollAnimation animateIn="fadeInUp" duration={1.5} delay={0.5}>
        <NewsContent>
          <p>Here is some interesting news related to our website...</p>
        </NewsContent>
      </ScrollAnimation>
    </Container>
  );
}
